module.exports = __webpack_public_path__ + "static/media/PORTADA.0152d895.JPG";